/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Area_Map_TitleInputs */

const vi_area_map_title = /** @type {(inputs: Area_Map_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản đồ vùng trồng`)
};

/**

* @param {Area_Map_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const area_map_title = /** @type {((inputs?: Area_Map_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Area_Map_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_area_map_title(inputs)
});